import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import { consumeAuthRedirectMessage } from '../../services/sessionMigration';
import { LoginForm } from './LoginForm';
import { RegisterForm } from './RegisterForm';
import { ClientShellSwitcher } from '../common/ClientShellSwitcher';
import {
  getClientShell,
  getPathForClientShell,
  setClientShell,
  type ClientShell,
} from '../../constants/clientShell';
import './AuthStyles.css';

export const AuthPage: React.FC = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [clientShell, setClientShellState] = useState<ClientShell>(() => getClientShell());
  const clientShellRef = useRef(clientShell);
  clientShellRef.current = clientShell;
  const navigate = useNavigate();

  useEffect(() => {
    const redirectMessage = consumeAuthRedirectMessage();
    if (redirectMessage) {
      message.info(redirectMessage);
    }
  }, []);

  const navigateForShell = useCallback((shell: ClientShell) => {
    setClientShell(shell);
    navigate(getPathForClientShell(shell), { replace: true });
  }, [navigate]);

  const handleShellChange = (shell: ClientShell) => {
    setClientShell(shell);
    setClientShellState(shell);
  };

  const handleLoginSuccess = () => {
    navigateForShell(clientShellRef.current);
  };

  const switchToRegister = () => {
    setIsLogin(false);
  };

  const switchToLogin = () => {
    setIsLogin(true);
  };

  return (
    <div className="auth-page">
      <div className="auth-shell-picker">
        <p className="auth-shell-picker__label">登录后进入</p>
        <ClientShellSwitcher value={clientShell} onChange={handleShellChange} variant="auth" />
      </div>
      {isLogin ? (
        <LoginForm
          onSuccess={handleLoginSuccess}
          onSwitchToRegister={switchToRegister}
        />
      ) : (
        <RegisterForm
          onSuccess={switchToLogin}
          onSwitchToLogin={switchToLogin}
        />
      )}
    </div>
  );
};

export default AuthPage;
